import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { AiFillStar } from 'react-icons/ai'

const FilterRating = ({handle}) => {

    const {rate, setRate} = handle;

    console.log(rate)
  return (
    <>
        <div className="rating d-flex ">
           
                <div>
                    <input type="checkbox" className='d-none' name="1" id="1"onChange={(e) => {setRate(e.target.id)}} />
                    <label htmlFor="1" className='pointer' ><AiFillStar className={`${rate >= 1 ? '': 'color'}`} /></label>
                </div>
                <div>
                    <input type="checkbox" className='d-none' name="1" id="2"onChange={(e) => {setRate(e.target.id)}} />
                    <label htmlFor="2" className='pointer' ><AiFillStar className={`${rate >= 2 ? '': 'color'}`}  /></label>
                </div>
                <div>
                    <input type="checkbox" className='d-none ' name="1" id="3" onChange={(e) => {setRate(e.target.id)}} />
                    <label htmlFor='3' className='pointer' ><AiFillStar className={`${rate >= 3 ? '': 'color'}`}  /></label>
                </div>
                <div>
                    <input type="checkbox" className='d-none ' name="1" id="4" onChange={(e) => {setRate(e.target.id)}} />
                    <label htmlFor='4' className='pointer' ><AiFillStar className={`${rate >= 4 ? '': 'color'}`}  /></label>
                </div>
                <div>
                    <input type="checkbox" className='d-none ' name="1" id="5" onChange={(e) => {setRate(e.target.id)}} />
                    <label htmlFor='5' className='pointer' ><AiFillStar className={`${rate >= 5 ? '': 'color'}`}  /></label>
                </div>
                

            

        </div>
    </>
  )
}

export default FilterRating